import { configureFetchMs } from '@/epersonam/configureFetchMs';
import errorManager from '@/rollbar.js';

const sendReportToMicroService = async (e) => {
  e.preventDefault();
  let params = { old_notification: true };
  $('#modal_cot_microservice').modal('hide');
  document.querySelectorAll('form#modal_search_cot_microservice input').forEach((input) => {
    const name = input.getAttribute('name');
    const value = input.value;
    params[name] = value;
  });
  try {
    eventBus.$emit('openAdvLoader');
    let urlGenerateReport = `${window.config.ePersonamService.apiCotHost}/${window.locale}/reports/generate_report.json`;
    const options = configureFetchMs('POST', JSON.stringify(params), false);
    const response = await fetch(urlGenerateReport, options);
    const data = await response.json();
    eventBus.$emit('generateReport', data);
    eventBus.$emit('closeAdvLoader');
  } catch (e) {
    eventBus.$emit('closeAdvLoader');
    errorManager(e);
  }
};

const setObserver = () => {
  const selector = document.querySelector('.cot-report-submit-microservice');
  selector.addEventListener('click', sendReportToMicroService);
};

const init = () => {
  try {
    setObserver();
  } catch (e) {
    errorManager(e);
  }
};

window.cotReports = {
  init: init,
};
